module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "do-filters text-dark"
  }, [_c('div', {
    staticClass: "do-filters__selected"
  }, [_c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.onClickOutside),
      expression: "onClickOutside"
    }],
    staticClass: "do-filters__dropdown__container"
  }, [_c('button', {
    staticClass: "do-bttn do-bttn__filter",
    on: {
      "click": function($event) {
        _vm.isShowDropdown = !_vm.isShowDropdown
      }
    }
  }, [_c('span', {
    staticClass: "icon-filter"
  }), _vm._v("\n        " + _vm._s(_vm.i18n['substitutes']) + "\n        "), _c('div', {
    staticClass: "do-filters__divider"
  }), _vm._v(" "), (_vm.allSelectedFiltersLength === 0) ? _c('span', {
    staticClass: "do-filters__selected-filters"
  }, [_vm._v("\n          " + _vm._s(_vm.i18n['select_filters']) + "\n        ")]) : [_c('span', {
    staticClass: "do-badge"
  }, [_vm._v("\n            " + _vm._s(_vm.allSelectedFiltersLength) + " " + _vm._s(_vm.i18n['selected']) + "\n          ")])]], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "d-dropdown"
    }
  }, [(_vm.isShowDropdown) ? _c('div', {
    staticClass: "do-filters__dropdown"
  }, [_c('button', {
    staticClass: "do-filters__button-transparent",
    on: {
      "click": function($event) {
        return _vm.$emit('clearAll')
      }
    }
  }, [_vm._v(_vm._s(_vm.i18n['clear_all']))]), _vm._v(" "), (_vm.isSortable) ? _c('h4', {
    staticClass: "do-filters__section-title"
  }, [_c('span', {
    staticClass: "icon-filter"
  }), _vm._v("\n            " + _vm._s(_vm.i18n['filters']) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "do-filters__dropdown__item"
  }, [_c('h5', [_vm._v(_vm._s(_vm.i18n['filter_by_criteria']))]), _vm._v(" "), _vm._l((_vm.quickFilters), function(quickFilter) {
    return _c('button', {
      key: quickFilter.value,
      staticClass: "do-bttn__quick-filter",
      class: {
        'do-bttn__quick-filter--selected': _vm.getIsQuickFilterSelected(quickFilter)
      },
      on: {
        "click": function($event) {
          return _vm.$emit('toggleQuickFilter', quickFilter)
        }
      }
    }, [_c('span', {
      staticClass: "icon-checkmark-circle"
    }), _vm._v("\n              " + _vm._s(_vm.i18n[quickFilter.titleKey]) + "\n            ")])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "do-filters__dropdown__item"
  }, [_c('h5', [_vm._v(_vm._s(_vm.i18n['filter_by_group']))]), _vm._v(" "), _c('DoFiltersFilter', {
    attrs: {
      "title": _vm.i18n['groups'],
      "tags": _vm.tags,
      "selectedTags": _vm.selectedTags
    },
    on: {
      "select": function($event) {
        return _vm.$emit('select', $event)
      },
      "clear": function($event) {
        return _vm.$emit('clear')
      }
    }
  }), _vm._v(" "), (_vm.isPresenceOption && _vm.selectedTags.length > 0) ? _c('div', {
    staticClass: "do-filters__presence"
  }, [_c('span', {
    staticClass: "do-filters__presence__label"
  }, [_vm._v(_vm._s(_vm.i18n['only_with_work_hours']))]), _vm._v(" "), _vm._l((_vm.selectedTags), function(tag) {
    return _c('button', {
      key: tag,
      staticClass: "do-bttn__quick-filter do-bttn__quick-filter--small",
      class: {
        'do-bttn__quick-filter--selected': _vm.groupsRequiringPresence.includes(tag)
      },
      on: {
        "click": function($event) {
          return _vm.$emit('togglePresenceGroup', tag)
        }
      }
    }, [_c('span', {
      staticClass: "icon-checkmark-circle"
    }), _vm._v("\n                " + _vm._s(tag) + "\n              ")])
  })], 2) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "do-filters__dropdown__item"
  }, [_c('h5', [_vm._v(_vm._s(_vm.i18n['filter_by_blocks']))]), _vm._v(" "), _c('DoFiltersFilter', {
    attrs: {
      "title": _vm.i18n['blocks'],
      "tags": _vm.eventTitleTags,
      "selectedTags": _vm.selectedEventTitles
    },
    on: {
      "select": function($event) {
        return _vm.$emit('selectEventTitle', $event)
      },
      "clear": function($event) {
        return _vm.$emit('clearEventTitles')
      }
    }
  })], 1), _vm._v(" "), (_vm.isSortable) ? _c('div', {
    staticClass: "do-filters__sort"
  }, [_c('div', {
    staticClass: "do-filters__sort__header"
  }, [_c('h4', {
    staticClass: "do-filters__section-title"
  }, [_c('span', {
    staticClass: "icon-shuffle2"
  }), _vm._v("\n                " + _vm._s(_vm.i18n['sorting']) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "do-filters__sort__toggle"
  }, [_vm._v("\n                " + _vm._s(_vm.i18n['sort_by_filters']) + "\n                "), _c('AppToggle', {
    attrs: {
      "propOn": _vm.isSortActive
    },
    on: {
      "changed": _vm.onToggleSort
    }
  })], 1)]), _vm._v(" "), _c('p', {
    staticClass: "do-filters__sort__hint"
  }, [_vm._v("\n              " + _vm._s(_vm.sortHint) + "\n            ")]), _vm._v(" "), _c('draggable', {
    attrs: {
      "value": _vm.sortItems,
      "disabled": !_vm.isSortActive
    },
    on: {
      "input": _vm.onSortInput
    }
  }, [_c('transition-group', {
    staticClass: "do-filters__sort__list",
    class: {
      'do-filters__sort__list--inactive': !_vm.isSortActive
    },
    attrs: {
      "type": "transition",
      "name": "do-filters-sort",
      "tag": "div"
    }
  }, _vm._l((_vm.sortItems), function(item, idx) {
    return _c('div', {
      key: item.key,
      staticClass: "do-filters__sort__item"
    }, [_c('div', {
      staticClass: "do-filters__sort__item__number"
    }, [_vm._v(_vm._s(idx + 1))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getSortItemTitle(item)))]), _vm._v(" "), _c('span', {
      staticClass: "do-filters__sort__item__type"
    }, [_vm._v(_vm._s(_vm.i18n['type_' + item.type]))]), _vm._v(" "), _c('span', {
      staticClass: "icon-menu do-filters__sort__item__handle"
    })])
  }), 0)], 1)], 1) : _vm._e()]) : _vm._e()])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-19ce66ea!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DoFilters/DoFilters.vue
// module id = 1781
// module chunks = 1